import {Translate} from "../../hoc/translate";
import './less/designer.less';

const designer = (props) => {
	let container = document.querySelector('.js-engraving-controls');
	let onCloseDesigner = () => {
	};
	
	if (container) {
		let preview = container.querySelector('.js-designer-preview');
		let remove = container.querySelector('.js-remove-designed-product');
		let input = container.querySelector('.js-custom-inscription');
		let image = container.querySelector('.js-designer-preview-image');
		let designer = document.querySelector('.js-designer');
		
		onCloseDesigner = () => {
			let svg = localStorage.getItem('designer_svg');
			let png = localStorage.getItem('designer_png');

			if (svg) {
				localStorage.removeItem('designer_svg')
			}
			
			if (png) {
				localStorage.removeItem('designer_png')
			}

			// setTimeout(function() {
			// 	console.log(svg, 'designer svg');
			// 	console.log(png, 'designer png');
			// }, 2000);
			
			if (svg && png) {
				designer.classList.add('hidden');
				container.classList.remove('hidden');
				image.classList.remove('hidden');
				
				preview.href = preview.dataset.href + '/data/orders/' + png;
				image.src = image.dataset.href + '/data/orders/' + png;
				
				remove.dataset.png = png;
				remove.dataset.svg = svg;
				input.value = JSON.stringify({'png': png, 'svg': svg});
				
				remove.addEventListener('click', e => {
					e.preventDefault();
					
					if (confirm(props.translate('confirm_remove_designer_project'))) {
						let target = e.currentTarget;
						let req = $.ajax({
							'type': 'post',
							'dataType': 'json',
							'url': target.href,
							'data': {
								'svg': target.dataset.svg,
								'png': target.dataset.png
							}
						});
						
						req.then(response => {
							if (response.status && response.status === 'success') {
								target.dataset.svg = '#';
								target.dataset.png = '#';
								preview.href = '#';
								input.value = '';
								image.src = '';
								
								designer.classList.remove('hidden');
								image.classList.add('hidden');
								container.classList.add('hidden');
							}
						});
					}
				});
			}
		};
	}
	
	return {
		'onCloseDesigner': onCloseDesigner
	};
};

export default Translate(designer);


// WEBPACK FOOTER //
// ./components/productDetails/designer.js